
import AccountService from '@/account/account.service';
import ScheduleEventMixin from '@/core/application-dictionary/mixins/ScheduleEventMixin';
import DocumentReservationMixin from '@/core/application-dictionary/mixins/DocumentReservationMixin';
import HtmlEditor from '@/shared/components/HtmlEditor/index.vue';
import { AccountStoreModule } from '@/shared/config/store/account-store';
import { Component, Inject, Mixins, Vue, Watch } from "vue-property-decorator";
import {debounce, isEmpty} from 'lodash';
import SelectGroupingEmail from '@/shared/components/SelectGroupingEmail/index.vue';
import DynamicWindowService from '@/core/application-dictionary/components/DynamicWindow/dynamic-window.service';

const tableName="m_chat_room";
const AttachmentProp= Vue.extend({
    props : {
        roomId: {
            type: Number,
            default: ()=> null
        }
    }
})

@Component
export default class Attachment extends Mixins(AttachmentProp){


    @Inject('accountService')
    private accountService: () => AccountService;
    @Inject('dynamicWindowService')
    protected commonService: (baseApiUrl: string) => DynamicWindowService;

    tableId: number= null;

    accept= ".jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .csv, .ppt, .pptx, .pdf";
    action= "/api/c-attachments/upload";
    limit= 1;

    fileList: any[]=[];

    beforeUpload(file){

        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            this.$notify({
                title: 'Warning',
                message: "files with a size less than 5Mb",
                type: 'warning',
                duration: 3000
            });
            return isLt5M;
        }

        // File type restriction
        const name = file.name ? file.name : '';
        const ext = name ? name.substr(name.lastIndexOf('.') + 1, name.length) : true;
        const isExt = this.accept.indexOf(ext) < 0;

        if (isExt) {
        this.$notify({
            title: 'Warning',
            message: "Please upload the correct format type",
            type: 'warning',
            duration: 3000
        });
        return false;
        }
    }

    created(): void {

    }

    mounted(): void {

    }

    getTableId(): void {

    }

    get headers(){
        if (this.accountService().hasToken) {
            return {
              'Authorization': `Bearer ${this.accountService().token}`
            }
        }
      
        return {};
    }

    onError():void {
        this.$message.warning("an error accured");
    }

    onExceed(files, fileList) {
        if(files.length >= 1) {
            this.$notify({
              title: 'Warning',
              message: "Up to 1 files are allowed",
              type: 'warning',
              duration: 3000
            });
            return false;
          }
    }

    onPreview(file){
        window.open(file.url, '_blank');
    }

    onRemove(file){
        if (file.id) {
            this.commonService("/api/ad-table-attachments")
              .delete(file.id)
              .then()
              .finally(() => {
      
                this.fileList= this.fileList.filter(f=> file.id != f.id);
              });
          }
    }

    onSuccess(response, file, fileList){
        // console.log({file});
        // console.log({response});
        // console.log({fileList});

        let f= {
            name : response.attachment.fileName,
            url: response.downloadUri, 
            file: file,
        }
        this.fileList.push(f);

        // setTimeout(()=> {
        //     this.$emit("uploaded", f);
        //     this.fileList= [];
        // }, 1000);
    }

    sendDocument(): void {
        if(this.fileList.length == 0) return ;
        this.$emit('uploaded', this.fileList[0]);
        this.fileList= [];
    }
}